import { PlaylistExamplesContentFileBridge, PlaylistsExamples } from "../../api-models/content";
import { PlaylistExampleFiles } from "./playlist-example-files";

export class PlaylistsExamplesCompletePlaylist {
    PlaylistExample: PlaylistsExamples;
    PlaylistExamplesFileBridge: PlaylistExamplesContentFileBridge[];
    PlaylistFiles: PlaylistExampleFiles[];
}